import type { SeverityLevel } from "@sentry/core";

export const DEFAULT_BREADCRUMB_LEVEL: SeverityLevel = 'info';
